import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getScriptSave } from '../../redux/reducer/coreScriptReducer';
import { useMemo } from 'react';

export function formatValue(question: any, value: any) {
  if ((question?.Type === 'Date' || question?.Type === 'DateTime') && value) {
    return dayjs(value)?.format('MM/DD/YYYY');
  }

  if (typeof value === 'string') return value?.toLanguagePack();

  if (value === '') return '-';

  if (Array.isArray(value)) {
    return value?.map((item) => item.toLanguagePack()).join(',');
  }

  return value;
}

export function filterData(data: any, isFlagged: boolean, saveData: any) {
  return isFlagged
    ? data
        ?.map((entry: any) => {
          // Filter the 'data' array based on CompletedDecision and visualisation required
          const filteredInnerData = entry?.data?.filter((item: any) => {
            // eslint-disable-next-line unicorn/consistent-function-scoping
            const isVisualisationRequired = (question: any) => {
              const allAnswers =
                saveData?.Answers[question?.Title]?.Answers || [];
              const activeAnswers = allAnswers.filter(
                (ans: any) => ans?.Active !== false
              );

              if (
                question?.Required &&
                (activeAnswers.length === 0 ||
                  question?.ErrorMessage ||
                  question?.AuditDecision)
              )
                return true;
              if (!question?.MediaComplete) return true;
              if (Array.isArray(question?.Medallions)) return true;
              return false;
            };

            return isVisualisationRequired(item);
          });

          // If there are valid filtered items, return the entry with filtered data
          if (filteredInnerData?.length > 0) {
            return { ...entry, data: filteredInnerData };
          }
          // Otherwise, exclude this entry by returning null
          return null;
        })
        ?.filter((entry: any) => entry !== null)
    : data;
}

export function useVisualisationRequired(question: any) {
  const saveData = useSelector(getScriptSave);

  const allAnswers = saveData?.Answers[question?.Title]?.Answers || [];
  const activeAnswers = allAnswers.filter((ans: any) => ans?.Active !== false);

  if (
    question?.Required &&
    (activeAnswers.length === 0 || question?.ErrorMessage)
  )
    return true;

  if (!question?.MediaComplete) return true;

  if (
    (question?.Medallions?.length > 0 || question?.Medallions?.length === 0) &&
    !question?.AuditDecision?.DecisionId
  )
    return true;

  return false;
}

export const useStationBadgeCount = (data: any) => {
  const saveData = useSelector(getScriptSave);

  const filteredInnerData = useMemo(() => {
    return data?.filter((item: any) => {
      return isVisualisationRequired(item, saveData);
    });
  }, [data, saveData]);

  return filteredInnerData?.length;
};

export const useVisulizationCountInStation = (stationsList: any[]) => {
  const saveData = useSelector(getScriptSave);

  const totalVisualizationCount = useMemo(() => {
    return stationsList?.reduce((totalCount, station) => {
      const data = station?.data || []; // Ensure station data is handled properly
      const filteredData = data.filter((item: any) =>
        isVisualisationRequired(item, saveData)
      );
      return totalCount + filteredData.length;
    }, 0); // Start total count at 0
  }, [stationsList, saveData]);

  return totalVisualizationCount;
};

const isVisualisationRequired = (question: any, saveData: any) => {
  const allAnswers = saveData?.Answers[question?.Title]?.Answers || [];
  const activeAnswers = allAnswers.filter((ans: any) => ans?.Active !== false);

  if (
    question?.Required &&
    (activeAnswers.length === 0 ||
      (question?.ErrorMessage && question?.ErrorType === 'error'))
  )
    return true;
  //sometimes the answer is empty string
  if (
    question?.Required &&
    (activeAnswers.length === 0 || activeAnswers[0]?.Answer === '')
  )
    return true;

  if (!question?.MediaComplete) return true;
  if (
    Array.isArray(question?.Medallions) &&
    !question?.AuditDecision?.DecisionId
  )
    return true;
  return false;
};
